import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "placeholder", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    onfocus: "this.setAttribute('autocomplete', 'new-address');",
    autocorrect: "off",
    autocapitalize: "off",
    spellcheck: "false",
    ref: "autocomplete",
    type: "search",
    role: "searchbox",
    id: _ctx.id,
    placeholder: _ctx.placeholder,
    value: _ctx.value,
    onSearch: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSearch($event))),
    onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFocus())),
    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBlur())),
    onKeypress: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
    onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args))),
    onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onKeyUp && _ctx.onKeyUp(...args)))
  }, null, 40, _hoisted_1))
}